<script>
    // Квест-худ (Task Info) — дизайн Living City. Положение задаётся в редакторе
    // худа (блок «quest»); по умолчанию — под основным худом справа.
    // Логика не менялась: те же сторы и вызовы client.quest.selectQuest.*.
    import { translateText } from 'lang'
    import { fly } from 'svelte/transition';
    import { getQuest } from 'json/quests/quests.js';
    import { storeQuests, selectQuest } from 'store/quest'
    import keys from 'store/keys'
    import keysName from 'json/keys.js'
    import { executeClient } from 'api/rage'
    import { isHelp } from 'store/hud'
    import { hudEditMode } from 'store/hudlayout'
    import HudBox from './hudbox.svelte'

    let QuestsList = [];
    let OldQuest = [];

    let quest = false;
    const onSelectQuest = (actorName) => {

        const listIndex = QuestsList.findIndex(q => q.ActorName == actorName);
        if (QuestsList [listIndex]) {
            quest = QuestsList [listIndex];
            return;
        }
        quest = false;
    }

    storeQuests.subscribe((value) => {
        if (value && value.length && OldQuest != value) {
            executeClient ("client.quest.selectQuest.Clear");

            OldQuest = value;
            QuestsList = [];

            value.forEach(questData => {
                const questInfo = getQuest(questData.ActorName, questData.Line);

                if (questInfo && questInfo.Title && questInfo.Tasks && questInfo.Tasks [questData.Stage]) {
                    executeClient ("client.quest.selectQuest.Add", questData.ActorName, (questInfo.Tasks.length - 1) === questData.Stage);

                    QuestsList.push ({
                        ActorName: questData.ActorName,
                        Title: questInfo.Title,
                        Desc: questInfo.Desc,
                        Tasks: questInfo.Tasks,
                        Reward: questInfo.Reward,
                        Stage: questData.Stage
                    });
                }
            });
            QuestsList = QuestsList;

            if (!quest && QuestsList.length && typeof QuestsList [0] === "object" && typeof $selectQuest !== "string") {
                quest = QuestsList [0];
                selectQuest.set (quest.ActorName);
                return;
            }

            onSelectQuest ($selectQuest);
        }
    });

    selectQuest.subscribe((value) => {
        onSelectQuest (value);
    });
</script>
{#if (quest && quest.Title && $isHelp) || $hudEditMode}
    <HudBox id="quest" label="задание">
        <div class="lcq-card" transition:fly={{ x: 16, duration: 260 }}>
            <div class="lcq-hairline"></div>
            <p class="lcq-kicker">◆ Задание</p>
            <h1 class="lcq-title">{@html quest && quest.Title ? quest.Title : 'Название задания'}</h1>
            <p class="lcq-desc">{@html quest && quest.Desc ? quest.Desc : 'Здесь будет описание текущего задания.'}</p>
        </div>
    </HudBox>
{/if}

<style>
    .lcq-card {
        position: relative;
        width: 30vh;
        box-sizing: border-box;
        padding: 1.2vh 1.4vh 1.3vh;
        border-radius: 1.3vh;
        background: rgba(16, 13, 10, 0.93);
        border: 1px solid rgba(231, 174, 63, 0.35);
        box-shadow: 0 1vh 3vh rgba(0, 0, 0, 0.5);
        font-family: 'Manrope', 'Gilroy', sans-serif;
        text-align: left;
    }
    .lcq-hairline { position: absolute; top: 0; left: 1.4vh; right: 1.4vh; height: 1px;
        background: linear-gradient(90deg, transparent, rgba(231, 174, 63, 0.6), transparent); }
    .lcq-kicker { margin: 0 0 .4vh; font-size: 0.95vh; font-weight: 700; letter-spacing: .18em;
        text-transform: uppercase; color: #e7ae3f; }
    .lcq-title { margin: 0 0 .5vh; font-size: 1.45vh; font-weight: 800; color: #fff; line-height: 1.25; }
    .lcq-desc { margin: 0; font-size: 1.2vh; font-weight: 600; color: rgba(243, 234, 214, 0.78); line-height: 1.45; }
</style>
